var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"projects"},[_vm._l((_vm.projects),function(project){return _c('router-link',{key:project.key,staticClass:"project",style:({ 'border-top-color': project.colour }),attrs:{"to":{ name: 'project', params: { id: project.key } },"tag":"div"}},[_vm._v("\n    "+_vm._s(project.name)+"\n  ")])}),_vm._v(" "),(_vm.isActive)?_c('NewProject'):_vm._e()],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a39b0c1","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/ProjectList.vue
// module id = null
// module chunks = 